import * as React from "react";
import { SVGProps } from "react";
export const ICircleIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_600_1711)">
            <mask
                id="mask0_600_1711"
                style={{
                    maskType: "alpha",
                }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={20}
                height={20}
            >
                <path d="M20 0H0V20H20V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_600_1711)">
                <path
                    d="M9.99999 18.333C8.84733 18.333 7.76399 18.1143 6.74999 17.677C5.73599 17.2397 4.85399 16.646 4.10399 15.896C3.35399 15.146 2.76033 14.264 2.32299 13.25C1.88566 12.236 1.66699 11.1527 1.66699 9.99999C1.66699 8.84733 1.88566 7.76399 2.32299 6.74999C2.76033 5.73599 3.35399 4.85399 4.10399 4.10399C4.85399 3.35399 5.73599 2.76033 6.74999 2.32299C7.76399 1.88566 8.84733 1.66699 9.99999 1.66699C11.1527 1.66699 12.236 1.88566 13.25 2.32299C14.264 2.76033 15.146 3.35399 15.896 4.10399C16.646 4.85399 17.2397 5.73599 17.677 6.74999C18.1143 7.76399 18.333 8.84733 18.333 9.99999C18.333 11.1527 18.1143 12.236 17.677 13.25C17.2397 14.264 16.646 15.146 15.896 15.896C15.146 16.646 14.264 17.2397 13.25 17.677C12.236 18.1143 11.1527 18.333 9.99999 18.333ZM9.99999 16.583C11.8193 16.583 13.3713 15.9407 14.656 14.656C15.9407 13.3713 16.583 11.8193 16.583 9.99999C16.583 8.18066 15.9407 6.62866 14.656 5.34399C13.3713 4.05933 11.8193 3.41699 9.99999 3.41699C8.18066 3.41699 6.62866 4.05933 5.34399 5.34399C4.05933 6.62866 3.41699 8.18066 3.41699 9.99999C3.41699 11.8193 4.05933 13.3713 5.34399 14.656C6.62866 15.9407 8.18066 16.583 9.99999 16.583Z"
                    fill="currentColor"
                />
                <path
                    d="M9.99505 5.35699C10.7746 5.35699 11.4066 5.98897 11.4066 6.76856C11.4066 7.54815 10.7746 8.18013 9.99505 8.18013C9.21548 8.18013 8.5835 7.54815 8.5835 6.76856C8.5835 5.98897 9.21548 5.35699 9.99505 5.35699Z"
                    fill="currentColor"
                />
                <path
                    d="M11.877 13.8937C11.877 14.1164 11.6964 14.297 11.4737 14.297H8.51609C8.29337 14.297 8.11279 14.1164 8.11279 13.8937V13.087C8.11279 12.8643 8.29337 12.6837 8.51609 12.6837H8.9194V10.5328H8.51609C8.29337 10.5328 8.11279 10.3522 8.11279 10.1295V9.32282C8.11279 9.1001 8.29337 8.91953 8.51609 8.91953H10.6671C10.8898 8.91953 11.0704 9.1001 11.0704 9.32282V12.6837H11.4737C11.6964 12.6837 11.877 12.8643 11.877 13.087V13.8937Z"
                    fill="currentColor"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_600_1711">
                <rect width={20} height={20} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
ICircleIcon.displayName = "ICircleIcon";
